import { AuctionItem, Bidder } from 'types/domain';

interface PriceOptions {
    formBuyNowPrice?: string;
}

const hasBuyNowPrice = (item: AuctionItem, options: PriceOptions = {}) => {
    if (options.formBuyNowPrice) {
        const price = parseFloat(options.formBuyNowPrice);
        return !isNaN(price) && price > 0;
    }

    return (item.price ?? 0) > 0;
};

const shouldEnterWinnerInfo = (item: AuctionItem) => {
    const itemTotalQuantity = item.total_quantity ?? 0;

    if (!item.allows_bid || itemTotalQuantity > 1) return true;
    if (item.highest_bid?.amount) return false;

    return hasBuyNowPrice(item);
};

const getItemSubtotal = (item: AuctionItem, highestBid?: string, buyNowPrice?: string) =>
    item.allows_bid && highestBid ? highestBid : buyNowPrice;

const getRequiresShippingAddress = (bidder: Bidder | null, item: AuctionItem) => {
    const hasPaymentMethods = bidder?.payment_methods && bidder.payment_methods.length > 0;

    return (item.require_shipping || hasPaymentMethods) && !bidder?.address;
};

export { hasBuyNowPrice, shouldEnterWinnerInfo, getItemSubtotal, getRequiresShippingAddress };
